export const PHONE = 'PHONE'
export const TABLET = 'TABLET'
export type DeviceType = 'PHONE' | 'TABLET'
